module.exports = __webpack_public_path__ + "img/logo_small_black.4e4e0d7f.svg";